<template>
  <div class="holder">
    <div class="title">Please note:</div>
    <ul>
      <li>We are unable to accept American Express card payments</li>
      <li>
        If you would like to make a payment of over &pound;500, please
        <a href="https://dataenergy.co.uk/payment-methods/" target="_blank"
          >visit our residents hub for more payment options</a
        >
      </li>
      <li v-if="!singleOption">
        Payments are made by {{ activePayment }}. To pay by
        {{ altPayment }} please
        <span class="link" @click="changeMethod">click here</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "PaymentNotes",
  data() {
    return {
      paymentOption: "stripe",
      activePayment: "bank payment",
      altPayment: "debit/credit card",
      singleOption: true
    };
  },
  created() {
    this.setDefault();
  },
  methods: {
    changeMethod() {
      if (this.paymentOption === "stripe") {
        this.setGC();
      } else {
        this.setStripe();
      }
      this.emit();
    },
    setDefault() {
      this.setStripe();
      this.emit();
    },
    setStripe() {
      this.paymentOption = "stripe";
      this.activePayment = "debit/credit card";
      this.altPayment = "bank payment";
    },
    setGC() {
      this.paymentOption = "gc";
      this.activePayment = "bank payment";
      this.altPayment = "debit/credit card";
    },
    emit() {
      this.$emit("payment", this.paymentOption);
    }
  }
};
</script>

<style lang="scss" scoped>
.holder {
  margin-top: 15px;
  text-align: left;
  font-size: 0.8rem;
  color: #777;

  .title {
    font-weight: bold;
  }
}

.link {
  cursor: pointer;
  color: #007bff;
}
</style>
